import MagioreBusiness1 from '../../../Media/Ruko Paramount/Magiore Business/Magiore Business Loft (1).webp'
import MagioreBusiness2 from '../../../Media/Ruko Paramount/Magiore Business/Magiore Business Loft (2).webp'
import MagioreBusiness3 from '../../../Media/Ruko Paramount/Magiore Business/Magiore Business Loft (3).webp'
import MagioreBusiness4 from '../../../Media/Ruko Paramount/Magiore Business/Magiore Business Loft (4).webp'

const MagioreBusinessimages =[
MagioreBusiness1,MagioreBusiness2,MagioreBusiness3,MagioreBusiness4
]

export default MagioreBusinessimages;
